import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ac12d1dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "asInput lUserEdit_input" }
const _hoisted_2 = { class: "asInput_label" }
const _hoisted_3 = { class: "lUserEdit_label" }
const _hoisted_4 = { class: "lUserEdit_checkboxes" }
const _hoisted_5 = ["data-text"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_as_avatar_upload = _resolveComponent("as-avatar-upload")!
  const _component_as_input = _resolveComponent("as-input")!
  const _component_v_field = _resolveComponent("v-field")!
  const _component_as_phone_input = _resolveComponent("as-phone-input")!
  const _component_as_date_select = _resolveComponent("as-date-select")!
  const _component_as_select = _resolveComponent("as-select")!
  const _component_as_radio = _resolveComponent("as-radio")!
  const _component_as_notice = _resolveComponent("as-notice")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("span", {
      class: _normalizeClass([_ctx.classTitle, "-small"]),
      "data-cy": "headerEditTitle"
    }, _toDisplayString(_ctx.$t(_ctx.title)), 3),
    _createVNode(_component_as_avatar_upload, {
      src: _ctx.user.avatar,
      onChange: _ctx.uploadAvatar,
      loading: !_ctx.saveAvatar
    }, null, 8, ["src", "onChange", "loading"]),
    _createVNode(_component_v_form, {
      class: "lUserEdit_form",
      onSubmit: _ctx.submit,
      onInput: _ctx.clear
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_field, {
          modelValue: _ctx.user.firstName,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.firstName) = $event)),
          modelModifiers: { trim: true },
          name: "name",
          label: _ctx.$t('firstName'),
          rules: "required"
        }, {
          default: _withCtx(({ errors }) => [
            _createVNode(_component_as_input, {
              name: "name",
              error: _ctx.getFirstError('name', errors),
              modelValue: _ctx.user.firstName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.firstName) = $event)),
              modelModifiers: { trim: true },
              class: "lUserEdit_input",
              label: _ctx.$t('firstName'),
              note: `(${_ctx.$t('required')})`,
              placeholder: _ctx.$t('input.firstName'),
              maxlength: "150"
            }, null, 8, ["error", "modelValue", "label", "note", "placeholder"])
          ]),
          _: 1
        }, 8, ["modelValue", "label"]),
        _createVNode(_component_v_field, {
          modelValue: _ctx.user.lastName,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.lastName) = $event)),
          modelModifiers: { trim: true },
          name: "lastName",
          label: _ctx.$t('lastName')
        }, {
          default: _withCtx(({ errors }) => [
            _createVNode(_component_as_input, {
              name: "lastName",
              error: _ctx.getFirstError('lastName', errors),
              modelValue: _ctx.user.lastName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.lastName) = $event)),
              modelModifiers: { trim: true },
              class: "lUserEdit_input",
              label: _ctx.$t('lastName'),
              placeholder: _ctx.$t('input.lastName'),
              maxlength: "150"
            }, null, 8, ["error", "modelValue", "label", "placeholder"])
          ]),
          _: 1
        }, 8, ["modelValue", "label"]),
        _createVNode(_component_as_input, {
          name: "email",
          "model-value": _ctx.user.email,
          class: "lUserEdit_input",
          label: _ctx.$t('email'),
          readonly: ""
        }, null, 8, ["model-value", "label"]),
        _createVNode(_component_v_field, {
          "model-value": _ctx.user.phone,
          name: "phone",
          label: _ctx.$t('phone')
        }, {
          default: _withCtx(({ errors }) => [
            _createVNode(_component_as_phone_input, {
              error: _ctx.getFirstError('phone', errors),
              "model-value": _ctx.user.phone || '',
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.onInputPhone($event))),
              class: "lUserEdit_input"
            }, null, 8, ["error", "model-value"])
          ]),
          _: 1
        }, 8, ["model-value", "label"]),
        _createVNode(_component_v_field, {
          modelValue: _ctx.user.city,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.user.city) = $event)),
          modelModifiers: { trim: true },
          name: "city",
          label: _ctx.$t('city')
        }, {
          default: _withCtx(({ errors }) => [
            _createVNode(_component_as_input, {
              name: "city",
              error: _ctx.getFirstError('city', errors),
              modelValue: _ctx.user.city,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.user.city) = $event)),
              modelModifiers: { trim: true },
              class: "lUserEdit_input",
              label: _ctx.$t('city'),
              placeholder: _ctx.$t('input.city'),
              maxlength: "100"
            }, null, 8, ["error", "modelValue", "label", "placeholder"])
          ]),
          _: 1
        }, 8, ["modelValue", "label"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t('birthday')), 1),
          _createVNode(_component_as_date_select, {
            modelValue: _ctx.birthday,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.birthday) = $event)),
            ref: "dateInputEl"
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(_component_v_field, {
          modelValue: _ctx.user.timezone,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.user.timezone) = $event)),
          name: "timezone",
          label: _ctx.$t('timezone')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_as_select, {
              "data-cy": "user_profile_timezone",
              modelValue: _ctx.user.timezone,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.user.timezone) = $event)),
              options: _ctx.allTimezones,
              search: "",
              placeholder: _ctx.$t('timezone'),
              "search-placeholder": _ctx.$t('input.timezone'),
              class: "lUserEdit_input"
            }, null, 8, ["modelValue", "options", "placeholder", "search-placeholder"])
          ]),
          _: 1
        }, 8, ["modelValue", "label"]),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('input.gender')), 1),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_as_radio, {
            name: "gender",
            "model-value": "M",
            checked: _ctx.user.gender === 'M',
            label: _ctx.$t('gender.M'),
            onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.user.gender = $event))
          }, null, 8, ["checked", "label"]),
          _createVNode(_component_as_radio, {
            name: "gender",
            "model-value": "F",
            checked: _ctx.user.gender === 'F',
            label: _ctx.$t('gender.F'),
            onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.user.gender = $event))
          }, null, 8, ["checked", "label"])
        ]),
        _createVNode(_component_as_notice, {
          class: "lUserEdit_notice",
          notice: _ctx.notice
        }, null, 8, ["notice"]),
        _createElementVNode("button", {
          class: "lUserEdit_button",
          "data-text": _ctx.button,
          "data-cy": "userProfile_save",
          type: "submit",
          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.scrollToError && _ctx.scrollToError(...args)))
        }, _toDisplayString(_ctx.button), 9, _hoisted_5)
      ]),
      _: 1
    }, 8, ["onSubmit", "onInput"])
  ]))
}